import React from 'react';

import type { GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid-premium';
import {
  getGridSingleSelectOperators,
  GridFilterInputMultipleSingleSelect,
} from '@mui/x-data-grid-premium';

import { usePreserveAutocompleteSearchInput } from './autocomplete-filter-utils';

function GridFilterInputMultipleSingleSelectPreserveSearch(
  props: GridFilterInputValueProps
): JSX.Element {
  const { inputValue, onInputChange } = usePreserveAutocompleteSearchInput();
  const inputProps = {
    ...props,
    inputValue,
    onInputChange,
  } as const;

  return <GridFilterInputMultipleSingleSelect {...inputProps} />;
}

export function getSingleSelectOperatorsWithPreservedSearch(): GridFilterOperator[] {
  return getGridSingleSelectOperators().map(operator => {
    if (operator.value !== 'isAnyOf' || !operator.InputComponent) return operator;

    return {
      ...operator,
      InputComponent: GridFilterInputMultipleSingleSelectPreserveSearch,
    };
  });
}
